<template>
    <div class="table-responsive">
        <base-table class="table align-items-center table-flush"
                    tbody-classes="list"
                    thead-classes="thead-light"
                    :data="profileDocuments">
            <template slot="columns">
                <th v-if="!short">#</th>
                <th>Gültig</th>
                <th v-if="typeof profile === 'undefined'">Profil</th>
                <th v-if="isAdmin">Organisation</th>
                <th v-if="!isService">Benutzer</th>
                <th>Typ</th>
                <th>Name</th>
                <th v-if="!short">Beschreibung</th>
                <th v-if="!short"><i v-on:click="order('issuedAt',(orderdir === 'desc' ) ? 'asc' : 'desc')" class="fas fa-sort"></i> Ausgestellt am</th>
                <th><i v-on:click="order('invalidAt',(orderdir === 'desc' ) ? 'asc' : 'desc')" class="fas fa-sort"></i> Läuft ab am</th>
                <th v-if="!short"></th>
            </template>
            <template slot-scope="{row}">
                <th v-if="!short" scope="row"><div v-if="isLoading" class="loading"> </div><div v-else>{{row.id}}</div></th>
                <th><div v-if="isLoading" class="loading"> </div><div v-else>{{!isExpired(row.invalidAt) ? $options.filters.formatDateFromNow(row.invalidAt) : 'abgelaufen'}}</div></th>
                <th v-if="typeof profile === 'undefined'"><div v-if="isLoading" class="loading"> </div><div v-else>{{(row.profile) ? row.profile.name : ''}}</div></th>
                <td v-if="isAdmin"><div v-if="isLoading" class="loading"> </div><div v-else>{{row.customer.name}}</div></td>
                <td v-if="!isService"><div v-if="isLoading" class="loading"> </div><div v-else>{{row.user.firstname}} {{row.user.lastname}}</div></td>
                <td><div v-if="isLoading" class="loading"> </div><div v-else>{{row.type}}</div></td>
                <td><div v-if="isLoading" class="loading"> </div><div v-else>{{row.name}}</div></td>
                <td v-if="isLoading">
                    <div class="loading"> </div>
                </td>
                <td v-else-if="!short" v-html="row.description">

                </td>
                <td v-if="!short"><div v-if="isLoading" class="loading"> </div><div v-else>{{row.issuedAt|formatDateToDay}}</div></td>
                <td><div v-if="isLoading" class="loading"> </div><div v-else>{{row.invalidAt|formatDateToDay}}</div></td>
                <td v-if="!short" class="text-right">
                    <div v-if="isLoading" class="loading"> </div><div v-else>
                    <base-button type="primary" size="sm" icon="fas fa-pencil-alt" v-on:click="$router.push('/users/profiles_document_edit/'+row.id)"></base-button>
                </div>
                </td>
            </template>
        </base-table>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name:"profile-document-table",
        props: {
            profile: {
                type: String,
                description: "Profile id",
                default: undefined
            },
            page: {
                type: String,
                description: "Page",
                default: undefined
            },
            short: {
                type: Boolean,
                description: "small table",
                default: false
            },
            onlyUpcoming: {
                type: Boolean,
                description: 'Filters on invalid Date',
                default: false
            }
        },
        data() {
            return {
                profileDocuments: [{
                    id: 0,
                    profile: null,
                    document: null,
                    customer: null,
                    user: null,
                    type: '',
                    name: '',
                    description: '',
                    invalidAt: '',
                    issuedAt: '',
                    createdAt: '',
                    }],
                isLoading: false,
                orderby: 'invalidAt',
                orderdir: 'asc',
            }
        },
        created() {
            this.isLoading = true;
            this.getTableData(this.getUrl()).then(response => {
                this.profileDocuments = response.member;
                this.isLoading = false;
            }, error => {
                this.isLoading = false;
                this.$store.dispatch('alert/error',error);
            })
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isService() {
                return this.$store.getters['authentication/isService'];
            }
        },
        methods: {
            isExpired(expiry) {
                return moment(expiry).diff(moment()) < 0
            },
            getUrl() {
                let date = new Date();
                let pagination = (typeof this.page === 'undefined') ? '&pagination=false' : '&page='+ this.page;
                let upcoming = (this.onlyUpcoming) ? '&invalidAt[after]=' + date.toISOString().split('T')[0] : '';
                let url = (typeof this.profile === 'undefined') ? process.env.VUE_APP_API_SERVER + '/api/profile_documents?order['+this.orderby+']='+this.orderdir + pagination + upcoming : process.env.VUE_APP_API_SERVER + '/api/profiles/'+this.profile+'/profile_documents?order['+this.orderby+']='+this.orderdir+pagination + upcoming;
                return url;
            },
            order(orderby,orderdir) {
                this.isLoading = true;
                this.orderby = orderby;
                this.orderdir = orderdir;
                this.getTableData(this.getUrl()).then(response => {
                    this.profileDocuments = response.member;
                    this.isLoading = false;
                    }
                );
            },
            getTableData(url){
                return new Promise((resolve, reject) => {

                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            }
        }
    }
</script>

<style scoped>

</style>